import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'

export const Route = createFileRoute('/nii-dashboard/$orgID')({
  component: RouteComponent,
  staticData: {
    title: 'NII Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  return <LibraDashboardPage />
}
